export const getInstance = state =>
  state && state.instance && state.instance.InstanceData;

export const getInstanceVersion = state =>
  state &&
  state.instance &&
  state.instance.InstanceData &&
  state.instance.InstanceData.version;
